export default {
    appName: 'MENUPOLY',
    AppTagline: 'dashboad',
    copyRight: 'Menupoly Inc. All Rights Reserved'
}
